// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { DataTableCssOverrides } from "@insite/mobius/DataTable/DataTable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { xBaseTheme } from "@werner/XDL/types";
import { color, ellipsis, xScreen } from "@werner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            cell: css`
                padding: 12px 8px;
                height: 54px;
                border-bottom: 0;
                max-width: 375px;
                min-width: 60px;
                ${xScreen("lte", "md")} {
                    white-space: nowrap;
                    max-width: initial;
                }
            `,
            head: css`
                background: transparent;
                border-bottom: 1px solid ${color("common.ui1", 0.75)};
                border-top: 3px solid ${color("common.ui1", 0.75)};
            `,
            header: css`
                background: transparent;
                padding: 12px 8px;
                height: 44px;
                border-bottom: 0;
            `,
            row: css`
                background: transparent;
                border-bottom: 1px solid ${color("common.ui1", 0.65)};
            `,
            evenRow: css`
                background: transparent;
            `,
        } as DataTableCssOverrides,
        headerTypographyProps: {
            mergeCss: true,
            size: 14,
            weight: 500,
            color: "text.main",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        cellTypographyProps: {
            mergeCss: true,
            size: 15,
            css: css`
                letter-spacing: 0;
                line-height: 60px;
            `,
        },
        sortClickableProps: {
            css: css`
                width: 100%;
                height: 100%;
            `,
        },
    },
} as xBaseTheme["dataTable"];
